"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("../../ctas/cta/link/link"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _imagepreview_styles = _interopRequireDefault(require("./imagepreview_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles

/* ========== ~~~~~~~~~~ EXPORT : BAR ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_imagepreview_styles.default)(function (props) {
  var renderImage = function renderImage() {
    return props.imgSrc ? _react.default.createElement("img", {
      className: 'preview',
      alt: 'uploaded image',
      src: props.imgSrc
    }) : null;
  };

  var renderFileName = function renderFileName() {
    if (!props.fileName && props.imgSrc || props.uploading) return null;
    return props.imgSrc ? _react.default.createElement("div", {
      className: 'filename'
    }, "\"", props.fileName, "\"") : 'No files selected';
  };

  var renderDiscard = function renderDiscard() {
    return props.imgSrc ? _react.default.createElement(_link.default, {
      text: 'Discard file',
      icon: 'trash-alt',
      color: 'error',
      type: 'action',
      action: props.discardFile
    }) : null;
  };

  return _react.default.createElement("div", {
    className: "imagepreview ".concat(props.classes.imagepreview)
  }, renderImage(), renderFileName(), renderDiscard());
});

exports.default = _default;